import request from '../../utils/request'
import { cacheTime } from '../../utils/constant'
import moment from 'moment'

const baseUrl = '/api/anonymous'

export default {
    namespaced: true,
    state: {
        info: null,
        cacheDate: {
            info: null
        }
    },
    getters: {

    },
    actions: {
        getInfo(context, { config = {}, options = {} }) {
            options = {
                cache: true,
                force: false,
                ...options,
            }
            if (context.state.cacheDate.info && context.state.cacheDate.info.isBefore(moment())) {
                options.force = true
            }
            const info = context.state.info
            if (info && !options.force) {
                return new Promise(reslove => reslove(info))
            }
            return request.get(`${baseUrl}/info`, config)
                .then(info => {
                    context.commit('setInfo', info)
                    return info
                })
        },
    },
    mutations: {
        setInfo(state, info) {
            state.info = info
            state.cacheDate.info = moment().add(cacheTime, 'ms')
        }
    },
}
